import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { defaultContainerSize, mq } from '../../../styles/mixins';

export const Wrapper = styled.section`
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: ${({ theme }) => theme.colors.light_grey};

  ${mq.small(css`
    padding-top: 5rem;
    padding-bottom: 5rem;
  `)};

  ${mq.xLarge(css`
    padding-top: 7.5rem;
    padding-bottom: 8.75rem;
  `)};
`;

export const Inner = styled.div`
  ${defaultContainerSize};
`;

export const Title = styled.h3`
  margin: 0 0 2rem 0;
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};

  ${mq.medium(css`
    margin-bottom: 4rem;
    font-size: 3rem;
    line-height: 3.5rem;
  `)};
`;

export const Stages = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 4rem;
  grid-row-gap: 2rem;

  ${mq.medium(css`
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 4rem;
  `)};

  ${mq.xLarge(css`
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  `)};
`;

export const Stage = styled.div`
  display: flex;
  align-self: self-start;

  ${mq.medium(css`
    flex-wrap: wrap;
  `)};
`;

export const StageIcon = styled.div`
  position: relative;
  height: 4rem;
  width: 4rem;
  margin-right: 1rem;

  ${mq.medium(css`
    margin-right: 0;
  `)};
`;

export const Content = styled.div`
  ${mq.medium(css`
    margin-top: 2.5rem;
    flex: 0 0 100%;
  `)};
`;

export const Subtitle = styled.h4`
  margin: 0 0 0.25rem 0;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.5rem;
  line-height: 2rem;

  ${mq.medium(css`
    margin-bottom: 1rem;
  `)};
`;

export const Description = styled.p`
  margin: 0;
  font-family: var(--font-second);
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.5rem;

  ${mq.medium(css`
    line-height: 2rem;
  `)};
`;
